import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { ReactComponent as UsernameIcon } from "../../assets/icon/gg_profile.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/icon/material-symbols_keyboard-arrow-down.svg";
import ConditionalRender from '../../components/Common/ConditionalRender';
import Input from '../../components/Common/Input';
import { formatRupiah } from '../../components/Common/utils';

const PaymentMethodComponent = ({
    paymentData,
    paymentLoading,
    selectedNominalItems,
    hargaFix,
    selectedPaymentItems,
    selectedrekPayment,
    setSelectedPaymentItems,
    setselectedrekPayment,
    type_payment
}) => {

    const [activeIndex, setActiveIndex] = useState(-1);

    const toggleAccordion = (index) => {
        console.log(selectedNominalItems);
        if ((selectedNominalItems) === undefined || (selectedNominalItems?.harga) === '0' || (selectedNominalItems?.harga) === 0 || (selectedNominalItems).length === 0) {

            toast.error("Harap pilih layanan terlebih dahulu", {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
        else {
            setselectedrekPayment([])
            if (activeIndex === index) {
                setActiveIndex(null);
            } else {
                setActiveIndex(index);
            }
        }
    };
    const handleInputChange = (value) => {
        const newInputs = [...selectedrekPayment];
        newInputs[0].value = value;
        setselectedrekPayment(newInputs);
    };

    return (
        <ConditionalRender
            productsData={paymentData}
            isLoading={paymentLoading}
            model={"emptyData"}
        >
            {paymentData.map((item, index) => {
                return (
                    <div key={index} className="flex flex-col">
                        <button className="flex mx-3 p-3 bg-[#22BDE2] flex-row justify-between items-center rounded-t-lg"
                            onClick={() => toggleAccordion(index)}>
                            <span className=" text-base font-medium line-clamp-1 text-darkColor">
                                {item.jenis}
                            </span>
                            <ArrowDownIcon fill="#ffffff" className={`-rotate-90 ${activeIndex === index && '-rotate-0'}`} />
                        </button>
                        {activeIndex !== index && (
                            <div className="flex mx-3 p-3 bg-lightColor dark:bg-darkColor flex-row justify-end gap-2 items-center rounded-b-lg shadow-inner overflow-hidden"
                            >
                                {item.metode_pembayaran.map((item, index) => {
                                    return (
                                        <img
                                            key={index}
                                            src={item.gambar}
                                            alt="logo"
                                            className={`sm:h-3 h-2 `}
                                        />
                                    );
                                })}
                            </div>)}

                        {activeIndex === index && (
                            <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-2 p-3 pt-2">
                                {item.metode_pembayaran.map((item, index) => {
                                    const getWebProfile = JSON.parse(localStorage.getItem("isProfile"));
                                    const selectedPriceLevel =
                                        getWebProfile?.level === "member"
                                            ? selectedNominalItems?.harga
                                            : getWebProfile?.level === "silver"
                                                ? selectedNominalItems?.harga_silver
                                                : getWebProfile?.level === "pro"
                                                    ? selectedNominalItems?.harga_pro
                                                    : getWebProfile?.level === "gold"
                                                        ? selectedNominalItems?.harga_gold
                                                        : selectedNominalItems?.harga;

                                    const typePayment = type_payment === "product" ? selectedPriceLevel : selectedNominalItems?.harga

                                    let selectedPriceFee = 0;
                                    if (parseInt(item.fee_persen) !== 0) {
                                        selectedPriceFee = parseInt(
                                            (parseFloat(item.fee_persen) / 100) * typePayment +
                                            parseInt(typePayment)
                                        );
                                    } else if (parseInt(item.fee_flat) !== 0) {
                                        selectedPriceFee =
                                            parseInt(item.fee_flat) + parseInt(typePayment);
                                    } else {
                                        selectedPriceFee = parseInt(typePayment);
                                    }
                                    return (
                                        <div className="flex flex-col gap-2 " key={index}>
                                            <button
                                                onClick={() => {
                                                    if (selectedNominalItems.length === 0) {
                                                        toast.error("Harap pilih layanan terlebih dahulu", {
                                                            position: toast.POSITION.TOP_RIGHT,
                                                        });
                                                    } else if (item.is_gangguan === "1") {
                                                        toast.error("Sedang Gangguan", {
                                                            position: toast.POSITION.TOP_RIGHT,
                                                        });
                                                    } else if (selectedPriceFee < item.minimal_pembayaran) {
                                                        toast.error("Tidak Tersedia, Minimal " + formatRupiah(item.minimal_pembayaran), {
                                                            position: toast.POSITION.TOP_RIGHT,
                                                        });
                                                    } else {
                                                        if (item.pake_rek === "1") {
                                                            setSelectedPaymentItems(item);
                                                            setselectedrekPayment([
                                                                {
                                                                    nama: item.nama,
                                                                    placeholder: item.keterangan_rek,
                                                                    value: "",
                                                                },
                                                            ]);
                                                        } else {
                                                            setSelectedPaymentItems(item);
                                                            setselectedrekPayment([]);
                                                        }
                                                        hargaFix({ harga: selectedPriceFee, logo: item.gambar })
                                                    }
                                                }}
                                                className={`p-2 relative bg-lightColor dark:bg-darkColor gap-2 shadow-inner flex w-full flex-col rounded-lg ${selectedPaymentItems?.id === item.id && 'border-2 border-[#22BDE2]'}`}>
                                                <div className='flex flex-row gap-2 justify-between  w-full'>
                                                    <div className=" flex flex-col justify-center flex-1 ">
                                                        <img
                                                            src={item.gambar}
                                                            alt={'icon_item ' + index} className={`flex flex-col w-16 max-h-12 object-contain`} />
                                                    </div>
                                                    <div className=" flex flex-col items-end flex-1 justify-center">
                                                        {selectedPriceFee < item.minimal_pembayaran ? (
                                                            <span className="text-xs  text-[#FF1515] text-right ">
                                                                Tidak Tersedia, Minimal{" "}
                                                                {formatRupiah(item.minimal_pembayaran)}
                                                            </span>
                                                        ) :
                                                            item.is_gangguan === "1" ? (
                                                                null
                                                            ) :
                                                                <span className={`  text-sm text-left  line-clamp-2`}>
                                                                    {formatRupiah(selectedPriceFee)}
                                                                </span>}
                                                    </div>
                                                </div>
                                                <div className='w-full h-[1px] bg-cardDark dark:bg-cardLight opacity-20' />
                                                <div className='flex flex-col sm:flex-row gap-2 sm:items-center items-start justify-between w-full'>
                                                    <span className="text-sm font-semibold text-left ">
                                                        {item.nama}
                                                    </span>
                                                    {item.is_gangguan === "1" ? (
                                                        <span className="text-xs text-right text-[#FF1515]">
                                                            {item.nama} Sedang Gangguan
                                                        </span>
                                                    ) :
                                                        <span className="text-xs text-right opacity-60">
                                                            Dicek Otomatis
                                                        </span>}
                                                </div>
                                                {selectedrekPayment.length === 0 ? null :
                                                    item.pake_rek === "0" ? null :
                                                        selectedPaymentItems?.id === item.id ?
                                                            <Input
                                                                id="phone"
                                                                icon={<UsernameIcon />}
                                                                name={selectedrekPayment[0].nama}
                                                                value={selectedrekPayment[0].value}
                                                                onChange={(value) => handleInputChange(value)}
                                                                type={
                                                                    selectedrekPayment[0].nama === "Saldo" ? "password" : "tel"
                                                                }
                                                                bgcolor={"bg-[#edeeee]"}
                                                                placeholder={selectedrekPayment[0].placeholder}
                                                            /> : null
                                                }
                                            </button>
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                    </div>
                )
            })}
        </ConditionalRender>
    );
};

export default PaymentMethodComponent;
